import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#f5f5f5] p-4">
      <div className="text-6xl font-bold text-[#ffa217]">404</div>
      <div className="mt-2 text-lg font-semibold text-[#333]">
        {t("Page not found")}
      </div>
      <Link
        to="/login"
        className="mt-6 rounded-lg bg-[#ffa217] px-6 py-2.5 font-semibold text-white transition hover:bg-[#e08f0e]"
      >
        {t("Go to Login")}
      </Link>
    </div>
  );
};

export default NotFoundPage;